module.exports = __webpack_public_path__ + "img/39.175e4adf.jpg";